import {Flex, Grid, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Category} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {ICategoryByProviderResponse, ProviderTypeEnum} from 'types';

interface Props {
  categories: ICategoryByProviderResponse[];
  t: (term: TranslationKeys) => string;
  onChange: (categorySlug: string) => void;
  providerType?: ProviderTypeEnum;
  activeCategory?: string;
}

export const CategoryProductsFilters: FC<Props> = ({onChange, t, categories, providerType, activeCategory}) => {
  return (
    <Flex flexDirection="column" p={['10px', '30px']} bg={colors.white} mb={['10px', '15px']} borderRadius="16px">
      <Text fontSize="16px" pt={['20px', '0px']} ml={['20px', '5px']} fontWeight="bold" mb="16px">
        {t('FILTER_BY_CATEGORY')}
      </Text>
      <Grid
        gap={['5px', '15px']}
        gridTemplateColumns="repeat(auto-fill, minmax(max(90px, 100px), 1fr))"
        justifyItems="center"
      >
        {categories.map((item, index) => (
          <Category
            key={index}
            {...item}
            providerType={providerType}
            onClick={onChange}
            onChange={onChange}
            activeCategory={activeCategory}
          />
        ))}
      </Grid>
    </Flex>
  );
};
